function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityIssue = function SvgActivityIssue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4761",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5567"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.818 502.653a2.137 2.137 0 0 0-.842-.842 2.526 2.526 0 0 0-2.431 0 2.137 2.137 0 0 0-.842.842l-6.566 11.5a2.181 2.181 0 0 0 2.057 3.2h13.133a2.18 2.18 0 0 0 2.057-3.2zm-2.057 3.892a.865.865 0 0 1 .572.211.681.681 0 0 1 .237.51v3.6a.68.68 0 0 1-.237.509.881.881 0 0 1-1.145 0 .685.685 0 0 1-.237-.509v-3.6a.686.686 0 0 1 .237-.51.868.868 0 0 1 .573-.211zm0 6.124a.865.865 0 0 1 .572.211.681.681 0 0 1 .237.51v.361a.68.68 0 0 1-.237.509.881.881 0 0 1-1.145 0 .685.685 0 0 1-.237-.509v-.361a.686.686 0 0 1 .237-.51.868.868 0 0 1 .573-.21z",
    "data-name": "Path 11628",
    style: {
      fill: "#e03861",
      fillRule: "evenodd"
    },
    transform: "translate(-398.76 -498.579)"
  })));
};
export default SvgActivityIssue;